<template>
    <div class="qr-generator">
        <b-form @submit="onSubmit" class="qr-generator_form">

            <b-form-group label="Уровень бюджета (level):">
                <b-form-radio v-model="level" value="1">1-УО</b-form-radio>
                <b-form-radio v-model="level" value="2">2-АБП</b-form-radio>
                <b-form-radio v-model="level" value="3">3-ГУ</b-form-radio>
            </b-form-group>

            <b-form-group label="Режим (mode):">
                <b-form-checkbox
                    id="checkbox-1"
                    v-model="brft"
                    name="checkbox-1"
                >
                    brft - текущие расходы бюджетной заявки
                </b-form-checkbox>
                <b-form-input v-model="brftRecordId" placeholder="brft record id"></b-form-input>
                <br>
                <b-form-checkbox
                    id="checkbox-2"
                    v-model="bipBr"
                    name="checkbox-2"
                >
                    bip_br - расходы развития бюджетной заявки
                </b-form-checkbox>
                <b-form-input v-model="bipBrRecordId" placeholder="bip_br record id"></b-form-input>
                <br>
                <b-form-checkbox
                    id="checkbox-3"
                    v-model="ceCa"
                    name="checkbox-3"
                >
                    ce_ca - текущие расходы заключения УО
                </b-form-checkbox>
                <b-form-input v-model="ceCaRecordId" placeholder="ce_ca record id"></b-form-input>
                <br>
                <b-form-checkbox
                    id="checkbox-4"
                    v-model="bipCa"
                    name="checkbox-4"
                >
                    bip_ca - расходы развития заключения УО
                </b-form-checkbox>
                <b-form-input v-model="bipCaRecordId" placeholder="bipCa record id"></b-form-input>
                <br>
                <b-form-checkbox
                    id="checkbox-5"
                    v-model="bip"
                    name="checkbox-5"
                >
                    bip - 
                </b-form-checkbox>
                <b-form-input v-model="bipRecordId" placeholder="bip record id"></b-form-input>
            </b-form-group>

            <b-form-group label="АБП:">
                <b-form-input v-model="abp"></b-form-input>
            </b-form-group>

            <b-form-group label="ГУ:">
                <b-form-input v-model="gu"></b-form-input>
            </b-form-group>

            <b-form-group label="Версия:">
                <b-form-input v-model="variant"></b-form-input>
            </b-form-group>
            
            <b-form-group :label="`Размер QR = ${scale}:`">
                <b-form-input v-model="scale" type="range" min="1" max="10"></b-form-input>
            </b-form-group>

        <b-button type="submit" variant="primary">Получить QR</b-button>
        </b-form>
        <b-modal id="my-modal" ok-only>
            <div id="qr-generator_output"></div>
        </b-modal>
  </div>
</template>

<script>
    export default {
    name: 'qr-generator-test',
    components: { 
    },
    mounted() {


    },
    watch: {
        brftRecordId() {
            if (this.brftRecordId) {
                this.brft = true;
            }
        },

        bipBrRecordId() {
            if (this.bipBrRecordId) {
                this.bipBr = true;
            }
        },

        ceCaRecordId() {
            if (this.ceCaRecordId) {
                this.ceCa = true;
            }
        },

        bipCaRecordId() {
            if (this.bipCaRecordId) {
                this.bipCa = true;
            }
        },

        bipRecordId() {
            if (this.bipRecordId) {
                this.bip = true;
            }
        },

        brft() {
            if (!this.brft) {
                this.brftRecordId = null;
            }
        },

        bipBr() {
            if (!this.bipBr) {
                this.bipBrRecordId = null;
            }
        },

        ceCa() {
            if (!this.ceCa) {
                this.ceCaRecordId = null;
            }
        },

        bipCa() {
            if (!this.bipCa) {
                this.bipCaRecordId = null;
            }
        },

        bip() {
            if (!this.bip) {
                this.bipRecordId = null;
            }
        },
    },
    data() {
        return {
            level: 1,
            // hash: null,
            abp: null,
            gu: null,
            variant: null,
            scale: '5',
            brftRecordId: null,
            bipBrRecordId: null,
            bipRecordId: null,
            ceCaRecordId: null,
            bipCaRecordId: null,
            brft: false,
            bipBr: false,
            ceCa: false,
            bipCa: false,
            bip: false,
        }

    },
    methods: {
        async onSubmit(event) {
            event.preventDefault();
            const mode = this.getModeRecordId();
            const data = {
                level: this.level,
                mode: mode,
                abp: this.abp,
                gu: this.gu,
                variant: this.variant,
                scale: this.scale
            }
            const url = '/api-py/get-qr-code';
                const response = await fetch(url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json;charset=utf-8'
                    },
                    body: JSON.stringify(data)
                });
                if (response.ok) {
                    const contentType = response.headers.get('Content-Type');
                    if (contentType && contentType.includes('application/json')) {
                        const result = await response.json();
                        console.error('Ошибка:', result.error + result.message);
                        document.getElementById('output').textContent = result.error;
                    } else if (contentType && contentType.includes('image/png')) {
                        const blob = await response.blob();
                        const url = URL.createObjectURL(blob);
                        const img = document.createElement('img');
                        img.src = url;
                        img.alt = 'QR-код';
                        this.$bvModal.show('my-modal');
                        setTimeout(() => {
                            const qrContainer = document.getElementById('qr-generator_output');
                            qrContainer.innerHTML = '';
                            qrContainer.style.textAlign = 'center';
                            qrContainer.appendChild(img);
                        })
                        
                    } else {
                        console.error('Неизвестный формат');
                    }
                } 
        },

        getModeRecordId() {
            const mode = {}
            if (this.brft) {
                mode.brft = this.brftRecordId ? this.brftRecordId : null;
            }
            if (this.bipBr) {
                mode.bip_br = this.bipBrRecordId ? this.bipBrRecordId : null;
            }
            if (this.ceCa) {
                mode.ce_ca = this.ceCaRecordId ? this.ceCaRecordId : null;
            }
            if (this.bipCa) {
                mode.bip_ca = this.bipCaRecordId ? this.bipCaRecordId : null;
            }
            if (this.bip) {
                mode.bip = this.bipRecordId ? this.bipRecordId : null;
            }
            return mode;
        }
    },

    computed: {
        
    }
}

</script>

<style scoped>
    .qr-generator {
        padding: 0 25%;
        position: absolute;
        top: 120px;
        max-height: calc(100% - 120px);
        overflow-y: auto;
    }
    .qr-generator_form{
        padding: 5px;
    }
</style>
